const s = "af.add-to-web-project", t = class t extends CustomEvent {
  constructor() {
    super(s, { bubbles: !0, composed: !0 });
  }
};
t.EVENT_NAME = s;
let e = t;
export {
  s as EVENT_NAME,
  e as default
};
//# sourceMappingURL=AddToWebProjectEvent.js.map
